/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  TokenPaymaster,
  TokenPaymasterInterface,
  OracleHelper,
  UniswapHelper,
} from "../../../contracts/samples/TokenPaymaster";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20Metadata",
        name: "_token",
        type: "address",
      },
      {
        internalType: "contract IEntryPoint",
        name: "_entryPoint",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "_wrappedNative",
        type: "address",
      },
      {
        internalType: "contract ISwapRouter",
        name: "_uniswap",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "priceMarkup",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minEntryPointBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "refundPostopCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "priceMaxAge",
            type: "uint256",
          },
        ],
        internalType: "struct TokenPaymaster.TokenPaymasterConfig",
        name: "_tokenPaymasterConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "contract IOracle",
            name: "tokenOracle",
            type: "address",
          },
          {
            internalType: "contract IOracle",
            name: "nativeOracle",
            type: "address",
          },
          {
            internalType: "bool",
            name: "tokenToNativeOracle",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "tokenOracleReverse",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "nativeOracleReverse",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "priceUpdateThreshold",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cacheTimeToLive",
            type: "uint256",
          },
        ],
        internalType: "struct OracleHelper.OracleHelperConfig",
        name: "_oracleHelperConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minSwapAmount",
            type: "uint256",
          },
          {
            internalType: "uint24",
            name: "uniswapPoolFee",
            type: "uint24",
          },
          {
            internalType: "uint8",
            name: "slippage",
            type: "uint8",
          },
        ],
        internalType: "struct UniswapHelper.UniswapHelperConfig",
        name: "_uniswapHelperConfig",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "priceMarkup",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minEntryPointBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "refundPostopCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "priceMaxAge",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct TokenPaymaster.TokenPaymasterConfig",
        name: "tokenPaymasterConfig",
        type: "tuple",
      },
    ],
    name: "ConfigUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "preCharge",
        type: "uint256",
      },
    ],
    name: "PostOpReverted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Received",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "currentPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "previousPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cachedPriceTimestamp",
        type: "uint256",
      },
    ],
    name: "TokenPriceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
    ],
    name: "UniswapReverted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "actualTokenCharge",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "actualGasCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "actualTokenPrice",
        type: "uint256",
      },
    ],
    name: "UserOperationSponsored",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "unstakeDelaySec",
        type: "uint32",
      },
    ],
    name: "addStake",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "cachedPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cachedPriceTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "entryPoint",
    outputs: [
      {
        internalType: "contract IEntryPoint",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IPaymaster.PostOpMode",
        name: "mode",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "actualGasCost",
        type: "uint256",
      },
    ],
    name: "postOp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "priceMarkup",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minEntryPointBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "refundPostopCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "priceMaxAge",
            type: "uint256",
          },
        ],
        internalType: "struct TokenPaymaster.TokenPaymasterConfig",
        name: "_tokenPaymasterConfig",
        type: "tuple",
      },
    ],
    name: "setTokenPaymasterConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "minSwapAmount",
            type: "uint256",
          },
          {
            internalType: "uint24",
            name: "uniswapPoolFee",
            type: "uint24",
          },
          {
            internalType: "uint8",
            name: "slippage",
            type: "uint8",
          },
        ],
        internalType: "struct UniswapHelper.UniswapHelperConfig",
        name: "_uniswapHelperConfig",
        type: "tuple",
      },
    ],
    name: "setUniswapConfiguration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "tokenToWei",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswap",
    outputs: [
      {
        internalType: "contract ISwapRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unlockStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "force",
        type: "bool",
      },
    ],
    name: "updateCachedPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "newPrice",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
      {
        internalType: "bytes32",
        name: "userOpHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "maxCost",
        type: "uint256",
      },
    ],
    name: "validatePaymasterUserOp",
    outputs: [
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "validationData",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "weiToToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "withdrawAddress",
        type: "address",
      },
    ],
    name: "withdrawStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "withdrawAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wrappedNative",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type TokenPaymasterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TokenPaymasterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TokenPaymaster__factory extends ContractFactory {
  constructor(...args: TokenPaymasterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _token: PromiseOrValue<string>,
    _entryPoint: PromiseOrValue<string>,
    _wrappedNative: PromiseOrValue<string>,
    _uniswap: PromiseOrValue<string>,
    _tokenPaymasterConfig: TokenPaymaster.TokenPaymasterConfigStruct,
    _oracleHelperConfig: OracleHelper.OracleHelperConfigStruct,
    _uniswapHelperConfig: UniswapHelper.UniswapHelperConfigStruct,
    _owner: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<TokenPaymaster> {
    return super.deploy(
      _token,
      _entryPoint,
      _wrappedNative,
      _uniswap,
      _tokenPaymasterConfig,
      _oracleHelperConfig,
      _uniswapHelperConfig,
      _owner,
      overrides || {}
    ) as Promise<TokenPaymaster>;
  }
  override getDeployTransaction(
    _token: PromiseOrValue<string>,
    _entryPoint: PromiseOrValue<string>,
    _wrappedNative: PromiseOrValue<string>,
    _uniswap: PromiseOrValue<string>,
    _tokenPaymasterConfig: TokenPaymaster.TokenPaymasterConfigStruct,
    _oracleHelperConfig: OracleHelper.OracleHelperConfigStruct,
    _uniswapHelperConfig: UniswapHelper.UniswapHelperConfigStruct,
    _owner: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _token,
      _entryPoint,
      _wrappedNative,
      _uniswap,
      _tokenPaymasterConfig,
      _oracleHelperConfig,
      _uniswapHelperConfig,
      _owner,
      overrides || {}
    );
  }
  override attach(address: string): TokenPaymaster {
    return super.attach(address) as TokenPaymaster;
  }
  override connect(signer: Signer): TokenPaymaster__factory {
    return super.connect(signer) as TokenPaymaster__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TokenPaymasterInterface {
    return new utils.Interface(_abi) as TokenPaymasterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TokenPaymaster {
    return new Contract(address, _abi, signerOrProvider) as TokenPaymaster;
  }
}
